
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/smart-solar-renewable-energy-sydney/solar-repairs-and-maintenance-sydney",
      function () {
        return require("private-next-pages/services/smart-solar-renewable-energy-sydney/solar-repairs-and-maintenance-sydney.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/smart-solar-renewable-energy-sydney/solar-repairs-and-maintenance-sydney"])
      });
    }
  